import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    isPhone: false,
    language:'en'
  },
  mutations: {
    setLanguage(state,language){
      state.language = language
    }
  },
  modules: {
  }
});

export default store



// WEBPACK FOOTER //
// ./src/store/index.js